import React, { createContext, useContext, useMemo, useState } from "react";

const AppContext = createContext(null);
const USER_KEY = "zezo:user";
const LIST_KEY = "zezo:my-list";

const readStorage = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(() => readStorage(USER_KEY, null));
  const [myList, setMyList] = useState(() => readStorage(LIST_KEY, []));

  const signIn = (email) => {
    const next = { email, name: email.split("@")[0] };
    localStorage.setItem(USER_KEY, JSON.stringify(next)); setUser(next);
  };
  const signOut = () => { localStorage.removeItem(USER_KEY); setUser(null); };
  const toggleMyList = (movie) => setMyList((current) => {
    const media_type = movie.media_type || (movie.first_air_date ? "tv" : "movie");
    const exists = current.some((item) => item.id === movie.id && item.media_type === media_type);
    const next = exists
      ? current.filter((item) => !(item.id === movie.id && item.media_type === media_type))
      : [...current, { ...movie, media_type }];
    localStorage.setItem(LIST_KEY, JSON.stringify(next)); return next;
  });

  const value = useMemo(() => ({ user, myList, signIn, signOut, toggleMyList }), [user, myList]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
export const useApp = () => useContext(AppContext);
